var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_vm._m(0),_c('div',{staticClass:"grey"}),_c('div',{staticClass:"page_view"},[_c(_vm.view,{tag:"component"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"_p"},[_vm._v("新增订阅")])])
}]

export { render, staticRenderFns }